'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { GuidanceBlock } from './_utils/build-guidance-blocks.util';

import { Pill } from '@/components/ui/pill/pill.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { clientSanitizeInput } from '@/utils/client-sanitize-input';

interface CartGuidanceBlockProps {
  block: GuidanceBlock;
}

export function CartGuidanceBlock({ block }: CartGuidanceBlockProps) {
  const sanitizedInstructions = clientSanitizeInput(block.instructions);

  return (
    <section className="flex flex-col gap-3" data-testid={DataTestIdEnum.CART_GUIDANCE_BLOCK}>
      <Typography
        variant={TypographyVariant.MEDIUM_SUBTITLE}
        className="font-bold"
        data-testid={DataTestIdEnum.CART_GUIDANCE_BLOCK_TITLE}
      >
        {block.procedureName}
      </Typography>

      {block.tags.map((tag) => (
        <Pill
          key={tag}
          variant="light"
          label={tag}
          className="w-full justify-center"
          data-testid={DataTestIdEnum.CART_GUIDANCE_BLOCK_PILL}
        />
      ))}

      {sanitizedInstructions && (
        <div
          className="text-base font-normal text-gray-700"
          data-testid={DataTestIdEnum.CART_GUIDANCE_BLOCK_INSTRUCTIONS}
          dangerouslySetInnerHTML={{ __html: sanitizedInstructions }}
        />
      )}
    </section>
  );
}
